<template>
  <div class="modal-description">
    <h2 class="modal-description__title">
      Sua descrição
    </h2>

    <textarea
      v-model="updateUser.about"
      :placeholder="resume.about"
      class="modal-description__text"
    />

    <div class="modal-description__footer">
      <button
        class="cancelar"
        @click="close()"
      >
        Cancelar
      </button>
      <button
        class="confirmar"
        @click="updateSubmit"
      >
        Atualizar
      </button>
    </div>
  </div>
</template>


<script>

import { mapGetters, mapActions } from "vuex"

export default {
  name: "Description",

  data() {
    return {
      updateUser: {
        about: ''
      }
    }
  },

  computed: {
    ...mapGetters('auth', ['resume'])
  },

  methods: {
    ...mapActions('auth', ['update']),

    close() {
      this.$emit("close")
    },

    async updateSubmit() {
      // eslint-disable-next-line no-unused-vars
      let payload = Object.fromEntries(Object.entries(this.updateUser).filter(([_, v]) => v != null && v != ''));

      await this.update(payload)

      this.close()
    }
  }
}

</script>

<style lang="scss" scoped>

.modal-description {
  padding: 15px;
  width: 100%;
  max-width: 500px;

  h2 {
    color: #66788A;
    font-weight: 700;
    font-size: 2rem;
    margin-bottom: 10px;
  }

  &__text {
    width: 100%;
    display: block;
    height: 200px;
  }
  
  &__footer {
    display: flex;
    justify-content: space-between;
    padding-top: 30px;
    gap: 10px;

    button.cancelar {
      border: 2px solid #D3D3D3;
      border-radius: 4px;
      background: #FFFFFF;
      color: #8B8B8B;
      font-size: 1.25rem;
      font-weight: 700;
      width: 100%;
      padding: 8px 0;
    }

    button.confirmar {
      border: 2px solid #1D43FF;
      border-radius: 4px;
      background: #1D43FF;
      color: #fff;
      font-size: 1.25rem;
      font-weight: 700;
      width: 100%;
    }
  }
}
</style>